import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContextSemPaginacao,
  initialQueryResponse,
  QUERIES,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { getPlantoes } from './_requests'
import { useQueryRequest } from './QueryRequestProvider'
import { useModal } from '../../../../../components'
import { Plantao } from './_models'

const QueryResponseContext = createResponseContextSemPaginacao<Plantao>(initialQueryResponse)

export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const filtroPlantao = useMemo(
    () => ({
      dataInicio: state.inicio,
      dataFim: state.termino,
      codSetores: state.setor ? [state.setor] : undefined,
      codTipoPlantao: state.tipoPlantao || undefined,
    }),
    [state.inicio, state.termino, state.setor, state.tipoPlantao]
  )

  const isEnabled = Boolean(state.local && state.setor) && !isOpen

  const { isFetching, isError, refetch, data } = useQuery(
    [QUERIES.PEGA_PLANTAO, isOpen, filtroPlantao],
    () => getPlantoes(filtroPlantao),
    {
      cacheTime: 0,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      enabled: isEnabled,
    }
  )

  const response = isEnabled ? data : undefined

  return (
    <QueryResponseContext.Provider value={{ isLoading: isFetching, isError, refetch, response }}>
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
